<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">
					Amend Balance for <strong>{{ account ? account.name : tenant.companyName }}</strong>
				</p>
			</div>
		</div>

		<div class="row margin-b50">
			<div class="col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 w-full">
				<div class="card formPanel">
					<div class="content">
						<p class="textCenter row margin-b20">
							Current Balance:
							<strong class="margin-l10">{{
								$global.currencyGbp(account ? account.balanceGbp : tenant.balanceGbp, 2)
							}}</strong>
						</p>
						<div class="row margin-b20">
							<div class="col-xs-12">
								<div class="formGroup">
									<label class="textGrey">Adjust by (£GBP): </label>
									<input v-model="increment" type="number" step="0.01" />
								</div>
								<div class="formGroup mt-4">
									<label class="textGrey">Additional notes:</label>
									<div class="formGroup withIcon">
										<textarea
											v-model="user_notes"
											class="w-full rounded-sm px-2.5 py-2 text-[14px] transition"
											rows="4"
										></textarea>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg green" @click="save()">Confirm</a></li>
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import tenantsApi from '../scripts/tenants/tenants.api.js'
import accountsApi from '../scripts/accounts/accounts.api.js'

export default {
	inject: ['user', 'userRoles', 'showAmendBalanceModal', 'editTenant', 'editAccount'],
	props: ['tenant', 'account'],

	data() {
		return {
			increment: '0.00',
			user_notes: ''
		}
	},

	methods: {
		save() {
			if (this.account) {
				accountsApi
					.incrementBalanceGbp(this.account.id, this.increment, this.user_notes)
					.then((result) => {
						if (result && result.error)
							this.$swal({
								title: 'Error',
								icon: 'error',
								text: result.error,
								confirmButtonText: 'Try Again'
							})
						else this.editAccount.balanceGbp = result

						this.showAmendBalanceModal = false
					})
					.catch((err) => {
						console.error('Amending balance', err)
						this.showAmendBalanceModal = false
						this.$swal({
							title: 'Error',
							icon: 'error',
							text: err || 'Unknown error occurred',
							confirmButtonText: 'Try Again'
						})
					})
			} else if (this.tenant) {
				tenantsApi
					.incrementBalanceGbp(this.tenant.id, this.increment, this.user_notes)
					.then((newBalance) => {
						this.editTenant.balanceGbp = newBalance
						this.showAmendBalanceModal = false
					})
					.catch((err) => {
						console.error('Amending balance', err)
						this.showAmendBalanceModal = false
					})
			}
		},
		close() {
			this.showAmendBalanceModal = false
		}
	}
}
</script>
